import { defineComponent as P, ref as R, computed as c, onBeforeMount as A, watch as V, createBlock as m, openBlock as s, unref as n, withCtx as v, createElementVNode as o, createVNode as p, Transition as D, createElementBlock as h, createCommentVNode as u, mergeProps as y, toHandlers as L, resolveDynamicComponent as $, toRaw as z, normalizeClass as E, toDisplayString as O, renderSlot as j, normalizeStyle as H } from "vue";
import { RevButtonIcon as M } from "@ds/components/ButtonIcon";
import { RevIllustration as U } from "@ds/components/Illustration";
import { RevPortal as Y } from "@ds/components/Portal";
import q from "../../icons/generated/IconCross.vue2.js";
import { useI18n as F } from "@ds/plugin";
import { track as G } from "@ds/tracking/tracking";
import J from "../../translations/generic.translations.js";
import { tw as i } from "../../utils/tailwind.js";
import { TOAST_VISIBILITY_DURATION as K } from "./Toast.constant.js";
const Q = ["aria-live", "role"], W = { class: "flex items-center justify-between" }, X = { class: "flex flex-1 items-center" }, Z = { class: "flex-1" }, tt = { class: "text-static-default-hi body-2-bold" }, et = { class: "text-static-default-mid body-2 w-full min-w-full" }, ft = /* @__PURE__ */ P({
  name: "RevToast",
  inheritAttrs: !1,
  __name: "Toast",
  props: {
    name: {},
    title: {},
    opened: { type: Boolean },
    variant: {},
    iconSrc: { default: "" },
    icon: { default: void 0 },
    iconProps: { default: () => ({ alt: "", height: 32, width: 32 }) },
    duration: { default: K },
    closeAlternativeText: { default: void 0 },
    to: { default: "body" }
  },
  emits: ["close"],
  setup(w, { emit: T }) {
    const e = w, b = T, a = R(null), g = {
      neutral: "polite",
      success: "polite",
      error: "assertive"
    }, x = c(() => g[e.variant]), _ = {
      neutral: i`bg-static-info-hi`,
      success: i`bg-static-success-hi`,
      error: i`bg-static-danger-hi`
    }, C = c(() => [
      i`shadow-long rounded-sm fixed inset-x-0 top-0 m-16 min-w-0 overflow-hidden p-20 pr-12 md:left-auto md:right-16 md:top-16 md:min-w-300 md:max-w-400`,
      _[e.variant]
    ]), d = i`mr-16 h-32 max-w-32`, k = c(() => `animation-duration: ${e.duration}ms;`), B = {
      neutral: "status",
      success: "status",
      error: "alert"
    }, I = c(() => B[e.variant]);
    function r() {
      a.value !== null && window.clearTimeout(a.value), a.value = null;
    }
    function f() {
      b("close"), r();
    }
    function l() {
      r(), a.value = window.setTimeout(f, e.duration);
    }
    A(() => {
      e.opened && l();
    }), V(
      () => e.opened,
      (t) => {
        t && l(), G({
          action: "toast",
          context: {
            name: e.name,
            status: t ? "opened" : "closed"
          }
        });
      }
    );
    const S = F(), N = e.closeAlternativeText || S(J.buttonClose);
    return (t, ot) => (s(), m(n(Y), { to: t.to }, {
      default: v(() => [
        o("div", {
          "aria-atomic": "true",
          "aria-live": x.value,
          role: I.value
        }, [
          p(D, {
            "enter-active-class": "translate-x-0 translate-y-0 opacity-100 !duration-300 ease-in-out motion-safe:transition-all",
            "enter-from-class": "-translate-y-full !opacity-0 md:translate-x-full md:translate-y-0",
            "leave-active-class": "translate-x-0 translate-y-0 opacity-100 !duration-300 ease-in-out motion-safe:transition-all",
            "leave-to-class": "-translate-y-full !opacity-0 md:translate-x-full md:translate-y-0",
            mode: "out-in"
          }, {
            default: v(() => [
              t.opened ? (s(), h("div", y({
                key: 0,
                class: C.value
              }, L({
                focusin: r,
                focusout: l,
                mouseleave: l,
                mouseover: r
              }, !0)), [
                o("div", W, [
                  o("div", X, [
                    t.iconSrc ? (s(), m(n(U), y({ key: 0 }, t.iconProps, {
                      alt: t.iconProps.alt,
                      class: d,
                      height: t.iconProps.height,
                      src: t.iconSrc,
                      width: t.iconProps.width
                    }), null, 16, ["alt", "height", "src", "width"])) : u("", !0),
                    t.icon ? (s(), m($(z(t.icon)), {
                      key: 1,
                      class: E(d)
                    })) : u("", !0),
                    o("div", Z, [
                      o("span", tt, O(t.title), 1),
                      o("div", et, [
                        j(t.$slots, "default")
                      ])
                    ])
                  ]),
                  p(n(M), {
                    "alternative-text": n(N),
                    class: "ml-8 self-start",
                    icon: n(q),
                    variant: "secondary",
                    onClick: f
                  }, null, 8, ["alternative-text", "icon"])
                ]),
                a.value ? (s(), h("div", {
                  key: 0,
                  class: "border-static-default-hi absolute bottom-0 left-0 h-0 w-full border-b-4 motion-safe:animate-expand-width",
                  style: H(k.value)
                }, null, 4)) : u("", !0)
              ], 16)) : u("", !0)
            ]),
            _: 3
          })
        ], 8, Q)
      ]),
      _: 3
    }, 8, ["to"]));
  }
});
export {
  ft as default
};
